// ESM imports workaround for __webpack_public_path__ usage
// https://webpack.js.org/guides/public-path/#on-the-fly
__webpack_public_path__ = window.__webpack_public_path__;
